import { createAction } from 'redux-actions';
import message from '@itt/frontend-scaffold-components/dist/Message/Message';
import {
  RESET,
  SET_BASIC_INFO,
  SET_POLICIES,
  SET_USERS,
  SET_LOADING
} from './actionTypes';
import {
  updateDescription,
  getGroupDetails,
  assignUsers,
  assignPolicies
} from './service';
import STATUS_CODE from '../../../../request/statusCode';
import { INITIAL_BASIC_INFO } from './consts';

const setBasicInfo = createAction(SET_BASIC_INFO);

const setUsers = createAction(SET_USERS);

const setPolicies = createAction(SET_POLICIES);

const setLoading = createAction(SET_LOADING);

const reset = createAction(RESET);

const getDetails = ({ name }) => {
  return dispatch => {
    dispatch(setLoading(true));
    return getGroupDetails({ name }).then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        const {
          name,
          userCount,
          createdBy,
          createdDate,
          description,
          aliceRoleNamePattern,
          roles,
          privilegedAccountOnly,
          aliceManaged,
          users,
          policies
        } = res.data;
        dispatch(
          setBasicInfo({
            name,
            userCount,
            createdBy,
            createdDate,
            description,
            aliceRoleNamePattern,
            roles,
            aliceManaged,
            privilegedAccountOnly
          })
        );
        dispatch(setUsers(users));
        dispatch(setPolicies(policies));
        return;
      }
      dispatch(setBasicInfo(INITIAL_BASIC_INFO));
      dispatch(setUsers([]));
      dispatch(setPolicies([]));
    });
  };
};

const editBasicInfo = ({ name, description }) => {
  return dispatch => {
    return updateDescription({ name, description }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Group edited successfully !');
        dispatch(getDetails({ name }));
        return true;
      }
      return false;
    });
  };
};

const editUsers = ({ name, users }) => {
  return dispatch => {
    return assignUsers({ name, users }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('User updated successfully !');
        dispatch(getDetails({ name }));
        return true;
      }
      return false;
    });
  };
};

const editPolicies = ({ name, policies }) => {
  return dispatch => {
    return assignPolicies({ name, policies }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('Policy updated successfully !');
        dispatch(getDetails({ name }));
        return true;
      }
      return false;
    });
  };
};

export {
  setBasicInfo,
  setUsers,
  setPolicies,
  reset,
  getDetails,
  editBasicInfo,
  editUsers,
  editPolicies,
  setLoading
};
